import { FAQPageJsonLd } from "next-seo";
import React, { useMemo } from "react";
import FAQSection from "@/components/us-website/FAQSection/FAQSection";
import styles from "./ProductFAQ.module.scss";

const parseFaqs = (faqs) => {
  if (Array.isArray(faqs)) return faqs;
  if (typeof faqs === "string" && faqs.trim()) {
    try {
      const parsed = JSON.parse(faqs);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
};

const ProductFAQ = ({ faqs, productName }) => {
  const faqList = useMemo(() => parseFaqs(faqs), [faqs]);
  const hasFaqs = faqList.length > 0 && faqList[0]?.question;

  const faqItems = useMemo(
    () =>
      hasFaqs
        ? faqList.map((faq) => ({
            questionName: faq.question,
            acceptedAnswerText: faq.answer,
          }))
        : [],
    [faqList, hasFaqs]
  );

  if (!hasFaqs) return null;

  return (
    <>
      {faqItems.length > 0 && <FAQPageJsonLd mainEntity={faqItems} />}
      <div className={styles.wrapper}>
        <FAQSection
          faqs={faqList}
          industryName={productName}
          hideContactCard
        />
      </div>
    </>
  );
};

export default ProductFAQ;
